<template>
  <section id="relic-detail-base-upload">
    <img
      class="upload-cover"
      v-show="gettersRelicDetail.coverUrl"
      :src="gettersRelicDetail.coverUrl"
      alt=""
    />
    <div class="upload-cover flex-center" v-show="!gettersRelicDetail.coverUrl">
      <i class="upload-cover__icon iconfont icon-tupian"></i>
      <span class="upload-cover__tip font-label">封面为空</span>
    </div>

    <el-button
      type="text"
      class="upload-btn"
      @click="showChoosePopup = true"
      v-if="limitShow"
      >更换封面</el-button
    >
    <el-button type="text" class="upload-btn" v-if="!limitShow"></el-button>
    <relic-upload-choose-vue
      v-model="showChoosePopup"
      @onLocalUpdateCover="handleLocalUpdateCover"
      @onUpdateFromPhotoAlbum="handleUpdateFromPhotoAlbum"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import relicUploadChooseVue from './photo_popup/relic-upload-choose.vue';
export default {
  name: 'RelicDetailBaseUpload',
  components: {
    relicUploadChooseVue
  },
  computed: {
    ...mapGetters('relic', ['gettersRelicDetail']),
    ...mapGetters('login', ['limitShow'])
  },
  data() {
    return {
      showChoosePopup: false
    };
  },
  methods: {
    /**
     * 监听更新回掉
     */
    handleLocalUpdateCover() {
      this.$emit('onLocalUpdateCover');
    },
    /**
     * 监听图库更新上传毁掉
     */
    handleUpdateFromPhotoAlbum() {
      this.$emit('onUpdateFromPhotoAlbum');
    }
  }
};
</script>

<style lang="scss">
#relic-detail-base-upload {
  display: flex;
  align-items: flex-end;
  .upload {
    &-cover {
      flex-direction: column;
      width: 262px;
      height: 262px;
      color: $color-info;
      border-radius: 6px;
      background-color: #f2f2f2;
      &__icon {
        font-size: 42px;
      }
      &__tip {
        margin-top: 7px;
      }
    }
    &-btn {
      margin-left: 13px;
    }
  }
}
</style>
